'use client';

import { useLocale } from 'next-intl';
import { Image } from '@/components/ui';
import { Link } from '@/components/ui';
import { slugify } from '@/lib/utils';

type LocationRowProps = {
  id: string;
  name: string;
  logo: string | null;
  status: string;
  type: 'club' | 'location';
};

export default function LocationRow({
  id: _id,
  name,
  logo,
  status: _status,
  type,
}: LocationRowProps) {
  const locale = useLocale();
  const routePath = type === 'club' ? 'club' : 'location';

  return (
    <li className="flex items-center gap-3">
      <Link
        href={`/${locale}/${routePath}/${slugify(name)}`}
        className="group flex items-center gap-3"
        variant="subtle"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded bg-black/5 text-xs font-medium dark:bg-white/10">
          {logo ? (
            <Image
              src={logo}
              alt={name}
              className="h-12 w-12 rounded object-contain"
              width={64}
              height={64}
              sizes="64px"
            />
          ) : (
            name[0]?.toUpperCase()
          )}
        </div>
        <div className="text-sm group-hover:underline">{name}</div>
      </Link>
    </li>
  );
}
